/**
 * Card — surface card primitive.
 *
 * Two variants matching FOM:
 *   - 'panel'    : large outer wrapper for entire equipment sections
 *                  (background var(--bg-surface), 24px padding, 8px radius)
 *   - 'item'     : inner card for individual equipment items
 *                  (background var(--bg-elevated), 12px padding, 8px radius)
 *
 * The borderColor and opacity props let consumers express FOM's status borders
 * (green=avail, orange=assigned, red=notAvail, etc.) without re-implementing
 * the box itself.
 */
import type { CSSProperties, ReactNode } from 'react'

interface CardProps {
  variant?: 'panel' | 'item'
  borderColor?: string
  borderWidth?: 1 | 2
  opacity?: number
  marginBottom?: number
  style?: CSSProperties
  children: ReactNode
}

export default function Card({
  variant = 'item',
  borderColor,
  borderWidth = 2,
  opacity = 1,
  marginBottom,
  style,
  children,
}: CardProps) {
  const isPanel = variant === 'panel'
  return (
    <div
      style={{
        background: isPanel ? 'var(--bg-surface)' : 'var(--bg-elevated)',
        borderRadius: 8,
        border: borderColor
          ? `${borderWidth}px solid ${borderColor}`
          : isPanel
            ? '1px solid var(--border)'
            : 'none',
        padding: isPanel ? 24 : 12,
        opacity,
        marginBottom,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
